import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Breadcrumbs, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { PALETTE } from '~/assets/styles/base';

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin: ${({ $margin }) => $margin || '0 0 30px !important'};
`;

const StyledNavLink = styled(NavLink)`
  color: ${PALETTE.text.main};
  &:visited {
    color: ${PALETTE.text.main};
  }
`;
function PageLinkBar({ links, margin }) {
  return (
    <StyledBreadcrumbs
      $margin={margin}
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      data-testid="uiParts-PageLinkBar"
      variant="note1"
      sx={{ marginTop: 7 }}
    >
      {links.map((link, i, { length }) => {
        if (i + 1 === length) {
          // 最後の項目はリンクではありません
          return (
            <Typography
              variant="note1"
              key={i}
              color="text.main"
              data-testid={`uiParts-PageLinkBar-curr-${i}`}
            >
              {link.label}
            </Typography>
          );
        }
        return (
          <StyledNavLink
            key={i}
            to={link.routePath}
            style={{ textDecoration: 'underline' }}
            data-testid={`uiParts-PageLinkBar-link-${i}`}
          >
            {link.label}
          </StyledNavLink>
        );
      })}
    </StyledBreadcrumbs>
  );
}

PageLinkBar.propTypes = {
  links: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  margin: PropTypes.string,
};

export default PageLinkBar;
